import { render, staticRenderFns } from "./Jaccount.vue?vue&type=template&id=01d6d733"
import script from "./Jaccount.vue?vue&type=script&lang=js"
export * from "./Jaccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports